import type { ChainAnimationPayload, SkillCastStartPayload } from './types';

export interface MapPoint {
  x: number;
  y: number;
}

export function withParsedPayload<T>(
  animationName: string,
  payloadJson: string,
  onParsed: (payload: T) => void,
): void {
  try {
    onParsed(JSON.parse(payloadJson) as T);
  } catch (error) {
    console.error(`Failed to parse ${animationName} payload`, error);
  }
}

export function resolveBouncePositions(
  animationName: string,
  payload: ChainAnimationPayload,
  resolveEntityPosition: (entityId: string) => MapPoint | null,
): MapPoint[] | null {
  const positions: MapPoint[] = [];
  if (Array.isArray(payload.points) && payload.points.length >= 2) {
    for (const point of payload.points) {
      if (typeof point.x !== 'number' || typeof point.y !== 'number') {
        console.warn(`[playAnimation] Invalid point in ${animationName} payload`, point);
        return null;
      }
      positions.push({ x: point.x, y: point.y });
    }
    return positions;
  }

  if (!payload.bounces || payload.bounces.length < 2) {
    return null;
  }

  for (const entityId of payload.bounces) {
    const entityPosition = resolveEntityPosition(entityId);
    if (!entityPosition) {
      console.warn(`[playAnimation] Could not find entity ${entityId} for ${animationName}`);
      return null;
    }
    positions.push(entityPosition);
  }

  return positions;
}

export function resolveRemainingTicks(
  currentTick: number,
  payload: SkillCastStartPayload,
): number {
  return typeof payload.resolveTick === 'number' && Number.isFinite(payload.resolveTick)
    ? Math.max(1, payload.resolveTick - currentTick)
    : 1;
}
